import React, { useState } from "react";
import { Container } from "react-bootstrap";
import Layout from "../components/Layout";
import { toast } from "react-toastify";
import QrReader from "react-qr-scanner";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { giftPageLink, purchaseGift } from "../redux/actions/profile";

const QRScanner = () => {
  const [scannedData, setScannedData] = useState("");
  const dispatch = useDispatch();

  const { gift_id } = useParams();

  const handleScan = (result) => {
    if (result) {
      setScannedData(result.text);
      onScanSuccess(result.text);
    }
  };

  const handleError = (error) => {
    console.error("QR Scanner Error:", error);
    toast.error("Error scanning QR code");
  };

  const onScanSuccess = (qrData) => {
    console.log("QR Code Data:", qrData);
    // Extract medallion ID from URL
    const medallionId = qrData.split("/").pop();
    handlePurchaseGift(medallionId);
  };

  const handlePurchaseGift = async (medallion_id) => {
    try {
      const payload = {
        gift_id,
        medallion_id,
      };
      const response = await dispatch(giftPageLink(payload)).unwrap();
      if (response?.status === 200 && response?.link) {
        window.location.href = response.link;
      } else {
        toast.success(response?.message || "Added to cart successfully!");
      }
    } catch (error) {
      toast.error(error.message || "Failed to purchase gift");
    }
  };

  const handleManualInput = () => {
    const manualData = prompt("Enter QR code data manually:");
    if (manualData) {
      setScannedData(manualData);
      onScanSuccess(manualData);
    }
  };

  return (
    <Layout>
      <section className="memory-medallion">
        <Container className="py-5">
          <div className="text-center">
            <h2>QR Code Scanner</h2>
            <p>Scan a QR code to access memorial information</p>

            <div
              className="scanner-container"
              style={{ maxWidth: "400px", margin: "0 auto" }}
            >
              <div>
                <QrReader
                  delay={300}
                  onError={handleError}
                  onScan={handleScan}
                  style={{ width: "100%" }}
                  constraints={{
                    video: { facingMode: "environment" },
                  }}
                />
                {/* <div className="mt-3">
                <button className="btn btn-secondary" onClick={handleManualInput}>
                  Enter Manually
                </button>
              </div> */}
              </div>
            </div>

            {/* 
          {scannedData && (
            <div className="mt-4 p-3 bg-light rounded">
              <h5>Scanned Data:</h5>
              <p>{scannedData}</p>
            </div>
          )} */}
          </div>
        </Container>
      </section>
    </Layout>
  );
};

export default QRScanner;
